import React from 'react';
import { TreeDeciduous, Sprout, Leaf } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';
import ShareVisionCard from './ShareVisionCard';

const ICONS = [Sprout, Leaf, TreeDeciduous];

export default function Vision() {
  const { t } = useI18n();
  return (
    <section id="vision" className="relative py-24 lg:py-32 bg-[#f5efe3]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <span className="text-[#b88a2a] text-xs uppercase tracking-wider-xtra font-medium">{t.vision.eyebrow}</span>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#1f3a2a] mt-4 leading-[1.05]">{t.vision.title_1} <span className="italic">{t.vision.title_2}</span></h2>
          <p className="mt-6 text-[#4a5a4e] text-lg leading-relaxed">{t.vision.sub}</p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-5 items-stretch" data-testid="vision-mission-statements">
          {t.vision.statements.map((s, i) => (
            <div key={s.label} data-testid={i === 0 ? 'vision-statement' : 'mission-statement'} className="card-rise relative bg-[#1f3a2a] rounded-2xl p-8 lg:p-10 overflow-hidden">
              <span className="text-[#d4a63d] text-xs uppercase tracking-wider-xtra font-medium">{s.label}</span>
              <p className="mt-4 font-serif-display text-xl md:text-2xl text-[#f5efe3] leading-snug">{s.text}</p>
              {i === 0 && <ShareVisionCard statement={s} />}
            </div>
          ))}
        </div>

        <div className="mt-5 grid md:grid-cols-3 gap-5">
          {t.vision.cards.map((s, i) => {
            const Icon = ICONS[i];
            const num = String(i + 1).padStart(2, '0');
            return (
              <div key={s.title} className="card-rise relative bg-white border border-[#e5dcc5] rounded-2xl p-7">
                <span className="absolute top-5 right-6 font-serif-display text-5xl text-[#f0e9d8]">{num}</span>
                <div className="w-12 h-12 rounded-xl bg-[#1f3a2a] flex items-center justify-center text-[#d4a63d] mb-5 relative"><Icon size={22} strokeWidth={1.6} /></div>
                <h3 className="font-serif-display text-2xl text-[#1f3a2a] relative">{s.title}</h3>
                <p className="mt-3 text-[#4a5a4e] text-sm leading-relaxed relative">{s.text}</p>
              </div>
            );
          })}
        </div>

        <blockquote className="mt-16 max-w-3xl mx-auto text-center">
          <p className="font-serif-display italic text-2xl md:text-3xl text-[#1f3a2a] leading-snug">{t.vision.quote}</p>
          <footer className="mt-4 text-[#8a7a4e] text-xs uppercase tracking-wider-xtra">{t.vision.quoteRef}</footer>
        </blockquote>
      </div>
    </section>
  );
}
